import apiempresaweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
    selectById: (state) => (id) => state.list.find((item) => item.fopidformapagto === id) || {},
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find({ commit }, {
      where, ...params
    } = {}) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get('formapagto', { params: { ...where, ...params, orderBy: 'fopidformapagto' } }),
      ]);

      commit('SET_LIST', data);
      return data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
